module.exports = __webpack_public_path__ + "img/swift-booster-green.3c909e6a.png";